import { gql, TypedDocumentNode } from '@apollo/client'

import { ALERT_FRAGMENT } from 'features/alerts/api/fragments/alert'
import { PageForTableDTO } from '../types'

export const PAGE_FOR_TABLE_FRAGMENT: TypedDocumentNode<PageForTableDTO> = gql`
  ${ALERT_FRAGMENT}

  fragment PageForTableFragment on Page {
    customVariableTriggerEnabled
    domain {
      alerts {
        ...AlertFragment
      }
      name
    }
    id
    name
    path
    pathTriggerEnabled
    updatedAt
  }
`
